<section
    class="relative"
    [cdkMenuTriggerFor]="!disabled() ? c : null"
    [cdkMenuPosition]="position()"
>
    <app-input
        [color]="currentColor()"
        [size]="currentSize()"
        [rounded]="currentRounded()"
        [required]="required()"
        [readonly]="readonly()"
        [disabled]="disabled()"
        [autofocus]="autofocus()"
        [autocomplete]="autocomplete()"
        [spellcheck]="spellcheck()"
        [label]="label()"
        [(value)]="value"
        [placeholder]="placeholder()"
        (valueChange)="handleInput($event)"
        type="datetime-local"
    >
        <app-icon
            class="cursor-pointer theme-text"
            size="sm"
            icons
            [name]="icon() || 'solar:calendar-bold-duotone'"
            (click)="handleOpenCalendar()"
        />
    </app-input>
</section>

<ng-template #c>
    <div
        cdkMenu
        class="shadow-md fixed md:min-w-max md:inset-auto md:w-auto md:h-auto inset-0 items-center flex p-4 md:p-0 w-screen md:bg-transparent bg-black/70 h-screen z-[999] md:absolute md:top-[calc(100%+4px)]"
    >
        <app-input-calendar [date]="date()" (select)="handleSelect($event)" />
        <!-- [disabledPast]="disabledPast()"
      [disabledFuture]="disabledFuture()" -->
        <app-time-picker (pick)="handleTimePick($event)" />
    </div>
</ng-template>
